import {
  useQueryClient,
  useQuery,
  useMutation,
  keepPreviousData,
} from "@tanstack/react-query";
import { errorMessage, successMessage } from "../../../utils/helper";
import { getSyncHistoryList } from "../api/PosSyncApi";
import qs from "qs";

const syncHistoryListKeys = {
  all: ["syncHistory"],
  lists: () => [...syncHistoryListKeys.all, "lists"],
  productslist: (filters) => [...syncHistoryListKeys.lists(), filters],
};

export const useSyncHistoryListQueries = ({
  pagination,
  sorting,
  debouncedText,
  selectedDate,
  selectedStatus,
}) => {
  const queryClient = useQueryClient();
  let params = {};

  if (debouncedText) {
    params = { ...params, search: debouncedText };
  }
  if (selectedDate) {
    params = { ...params, sync_date: selectedDate };
  }
  if (selectedStatus !== "") {
    params = { ...params, status: selectedStatus };
  }
  if (sorting?.length > 0) {
    const sortByParams = sorting.reduce(
      (obj, item) =>
        Object.assign(obj, { [item.id]: item.desc ? "desc" : "asc" }),
      {},
    );
    params = {
      ...params,
      sort: sortByParams,
    };
  }

  const query = {
    params,
    paramsSerializer: (params) => qs.stringify(params, { encode: true }),
  };

  //list useQueryClient
  const listQuery = useQuery({
    queryKey: syncHistoryListKeys.productslist({ query, pagination }),
    queryFn: () => getSyncHistoryList({ query, pagination }),
    placeholderData: keepPreviousData,
    enabled: true,
  });

  return {
    listQuery,
  };
};
